import gql from 'graphql-tag'

export const UPDATE_NOTIFICATION = gql`
  mutation update_notification($id: ID!, $input: InputNotification) {
    update_notification(id: $id, input: $input) {
      id
      active
      channels
      log_filter {
        type
        lang
        sources {
          model_id
          model_name
        }
      }
    }
  }
`
